module.exports = __webpack_public_path__ + "static/media/rounded-red-fail.0a0c1638.svg";